<template>
  <div>
    <el-breadcrumb separator="/" style="margin-bottom: 20px;">
      <el-breadcrumb-item><a style="font-weight: 700; color: #333;">{{title}}</a></el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-table v-loading="loading" :data="tableData" stripe border highlight-current-row :header-cell-style="{background: '#f5f7fa', color: '#333'}" style="width: 100%;">
        <el-table-column label="序号" type="index" width="55"></el-table-column>
        <el-table-column label="批次名称" prop="batchName"></el-table-column>
        <!-- <el-table-column label="报名人数" prop="applyNumber" ></el-table-column> -->
        <el-table-column label="状态" >
          <template slot-scope="scope">
            <span style="color: #67c23a" v-if="scope.row.status == 1">开启中</span>
            <span style="color: #f56c6c" v-if="scope.row.status == 2">关闭中</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="city" width="200">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false"  @click="dtl(scope.row, scope.$index)" >查看</el-link>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.page"
        :page-sizes="[10, 20, 30, 40]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="queryInfo.total">
      </el-pagination> -->
    </el-card>
  </div>
</template>

<script>
import { getProjectAwardBatchList } from '@/api/admin'
export default {
  props: ['title'],
  data () {
    return {
      loading: false,
      queryInfo: {
        page: 1,
        pageSize: 1000,
        total: 0
      },
      tableData: []
    }
  },
  created () {
    this.getList()
  },
  methods: {
    dtl(row, index) {
      this.$emit('handleNext', row)
    },
    getList() {
      const params = {
        page: this.queryInfo.page,
        pageSize: this.queryInfo.pageSize
      }
      this.loading = true
      getProjectAwardBatchList(params).then(res => {
        this.loading = false
        if (res.code === '000') {
          this.tableData = res.result.records
          this.queryInfo.total = res.result.total
        }
      })
    },
    // 条数
    handleSizeChange(val) {
      this.queryInfo.pageSize = val
      this.queryInfo.page = 1
      this.getList()
    },
    // 页数
    handleCurrentChange (val) {
      this.queryInfo.page = val
      this.getList()
    }
  }
}
</script>
